import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=53d2f41c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=53d2f41c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d2f41c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d2f41c')) {
      api.createRecord('53d2f41c', component.options)
    } else {
      api.reload('53d2f41c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=53d2f41c&scoped=true&", function () {
      api.rerender('53d2f41c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aW8tzeM3yt3U/JS/comp/PopupBox.vue"
export default component.exports